import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { EventBroadcast } from '../entities/shared/event-broadcast';

@Injectable({ providedIn: 'root' })
export class BroadcastService {
  eventSubject = new Subject<EventBroadcast>();

  constructor() {}

  broadcast<T = unknown>(action: string, data: T): void {
    this.eventSubject.next({ action, data });
  }

  on<T>(action: string): Observable<T> {
    return this.eventSubject.asObservable().pipe(
      filter((e: EventBroadcast) => e.action === action),
      map((e) => e.data as T),
    );
  }
}
